import type { SeriesStreakItem } from '@/components/Series/SeriesStreakBar/internal/types'

export default function getLongestStreak(items: SeriesStreakItem[]) {
  const pastSessions = items.filter(item => item.hasEnded)

  let longestStreak = 0

  if (pastSessions.length > 0) {
    let tempStreak = 0
    for (const session of pastSessions) {
      if (session.attended === true) {
        tempStreak += 1
        if (tempStreak > longestStreak) {
          longestStreak = tempStreak
        }
      } else {
        tempStreak = 0
      }
    }
  }

  return longestStreak
}
